import { Typography, styled } from "@mui/material";
import React from "react";

export const SkillLeveltext = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize} !important;
        font-weight: 500;
    `
)

export const Authoritytext = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize} !important;
        font-weight: 500;
    `
)

export const StateGuidetext = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize} !important;
        font-weight: 500;
    `
)

export const DamaNotetext = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize} !important;
        font-weight: 500;
    `
)